var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaAvanzar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "13px",
    viewBox: "0 0 7 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avanzar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PANTALLAS-ESCAPE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pantalla-Instrucciones",
    transform: "translate(-196, -523)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.74548,536 C196.560951,536 196.363015,535.931551 196.217651,535.780745 C195.92745,535.47968 195.92745,535.00054 196.217651,534.699475 L201.218574,529.497375 L196.217651,524.309238 C195.92745,524.008173 195.92745,523.529032 196.217651,523.227968 C196.507851,522.926369 196.969703,522.926369 197.259903,523.214064 L202.788657,528.949791 C202.934021,529.100597 203,529.292034 203,529.49738 C203,529.702726 202.92062,529.894163 202.788657,530.04497 L197.259903,535.780696 C197.114539,535.931502 196.93001,536 196.74548,536 L196.74548,536 Z",
    id: "avanzar"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaAvanzar);
export default __webpack_public_path__ + "static/media/flecha-avanzar.f22aade6c97ff1e1b7f4ebe2e7a37d3f.svg";
export { ForwardRef as ReactComponent };